import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserCardioService } from 'src/app/services/user-cardio.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fit-videos',
  templateUrl: './fit-videos.component.html',
  styleUrls: ['./fit-videos.component.scss'],
})
export class FitVideosComponent {
  level: any;
  isLoading = false;
  next: any;
  prev: any;
  levelVideos: any;
  videoId = 0;
  video: any;

  levelExercises: any;

  constructor(
    private route: ActivatedRoute,
    private userCardioService: UserCardioService
  ) {
    this.levelVideos = this.userCardioService.levelVideos;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.route.params.subscribe((params) => {
      this.videoId = params.videoId;
      this.level = params.level;
      this.video = this.levelVideos[this.level][this.videoId];

      this.isLoading = false;
    });
  }

  getVideo(asset: string) {
    return environment.staticUrl + '/' + asset;
  }
}
